'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var regexpTag = '[object RegExp]';
var stringTag = '[object String]';
var numberTag = '[object Number]';
var booleanTag = '[object Boolean]';
var argumentsTag = '[object Arguments]';
var symbolTag = '[object Symbol]';
var dateTag = '[object Date]';
var mapTag = '[object Map]';
var setTag = '[object Set]';
var arrayTag = '[object Array]';
var functionTag = '[object Function]';
var arrayBufferTag = '[object ArrayBuffer]';
var objectTag = '[object Object]';
var errorTag = '[object Error]';
var dataViewTag = '[object DataView]';
var uint8ArrayTag = '[object Uint8Array]';
var uint8ClampedArrayTag = '[object Uint8ClampedArray]';
var uint16ArrayTag = '[object Uint16Array]';
var uint32ArrayTag = '[object Uint32Array]';
var bigUint64ArrayTag = '[object BigUint64Array]';
var int8ArrayTag = '[object Int8Array]';
var int16ArrayTag = '[object Int16Array]';
var int32ArrayTag = '[object Int32Array]';
var bigInt64ArrayTag = '[object BigInt64Array]';
var float32ArrayTag = '[object Float32Array]';
var float64ArrayTag = '[object Float64Array]';
exports.argumentsTag = argumentsTag;
exports.arrayBufferTag = arrayBufferTag;
exports.arrayTag = arrayTag;
exports.bigInt64ArrayTag = bigInt64ArrayTag;
exports.bigUint64ArrayTag = bigUint64ArrayTag;
exports.booleanTag = booleanTag;
exports.dataViewTag = dataViewTag;
exports.dateTag = dateTag;
exports.errorTag = errorTag;
exports.float32ArrayTag = float32ArrayTag;
exports.float64ArrayTag = float64ArrayTag;
exports.functionTag = functionTag;
exports.int16ArrayTag = int16ArrayTag;
exports.int32ArrayTag = int32ArrayTag;
exports.int8ArrayTag = int8ArrayTag;
exports.mapTag = mapTag;
exports.numberTag = numberTag;
exports.objectTag = objectTag;
exports.regexpTag = regexpTag;
exports.setTag = setTag;
exports.stringTag = stringTag;
exports.symbolTag = symbolTag;
exports.uint16ArrayTag = uint16ArrayTag;
exports.uint32ArrayTag = uint32ArrayTag;
exports.uint8ArrayTag = uint8ArrayTag;
exports.uint8ClampedArrayTag = uint8ClampedArrayTag;
